module.exports = __webpack_public_path__ + "static/media/NotoSansArabic-Light.baa23754.ttf";